<ion-header class="transparent absolute">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>

<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme">
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title my-color-blue">{{'__SC_SUMMARY_HEAD_MANAGER__' | translate}}</div>
        <div class="title-text">{{'__SC_SUMMARY_DESC1__' | translate}}</div>

        <div class="drop-title">{{'__SC_SUMMARY_DESC2__' | translate}}</div>
        <!--    <ion-select class="My-select" [(ngModel)]="managerId" (ionChange)="selectFilter('manager')" [interface]="'popover'">-->
        <!--        <ion-select-option [value]="0">{{'__SC_SELECT_TEAM__' | translate}}</ion-select-option>-->
        <!--        <ng-container *ngFor="let manager of managers">-->
        <!--            <ion-select-option [value]="manager.id">{{manager.full_name}}</ion-select-option>-->
        <!--        </ng-container>-->
        <!--    </ion-select>-->

        <ng-select class="My-dropdown" [(ngModel)]="managerId" (ngModelChange)="selectFilter('manager')"
                   [searchable]="false" [clearable]="false">
            <ng-option [value]="0">{{'__SC_SELECT_TEAM__' | translate}}</ng-option>
            <ng-option *ngFor="let manager of managers" [value]="manager.id">
                {{manager.full_name}}
            </ng-option>
        </ng-select>

        <div class="drop-title">{{'__SC_SUMMARY_DESC3__' | translate}}</div>
        <!--    <ion-select class="My-select" [(ngModel)]="scId" (ionChange)="selectFilter('sk')" [interface]="'popover'">-->
        <!--        <ng-container *ngFor="let skItem of scList">-->
        <!--            <ion-select-option [value]="skItem.id">{{skItem.name}}</ion-select-option>-->
        <!--        </ng-container>-->
        <!--    </ion-select>-->

        <ng-select class="My-dropdown" [(ngModel)]="scId" (ngModelChange)="selectFilter('sk')"
                   [searchable]="false" [clearable]="false">
            <ng-option [value]="0">{{'__SC_SELECT_GROUP__' | translate}}</ng-option>
            <ng-option *ngFor="let skItem of scList" [value]="skItem.id">
                {{skItem.name}}
            </ng-option>
        </ng-select>

        <div class="box">
            <div class="line">
                <div class="el">
                    <div class="circle my-background-red"></div>
                    {{'__SC_SUMMARY_ENTRY__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-black-dark"></div>
                    {{'__SC_SUMMARY_DEVELOPING__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-yellow"></div>
                    {{'__SC_SUMMARY_DELIVERY__' | translate}}
                </div>
            </div>
            <div class="line">
                <div class="el">
                    <div class="circle my-background-blue"></div>
                    {{'__SC_SUMMARY_ADD_DELIVERY__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-green"></div>
                    {{'__SC_SUMMARY_COACH&MENTOR__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-grey"></div>
                    {{'__SC_SUMMARY_NOT_COMPLETED__' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="skill-wrap content-wrap">
    <ng-container *ngFor="let item of data; let i = index;">
        <app-skills-checker-team-card [data]="item" [i]="i"></app-skills-checker-team-card>
    </ng-container>
</div>
<div class="skill-wrap content-wrap" *ngIf="data === null">
    <app-skeleton-list></app-skeleton-list>
</div>
